function setCookie(name, value, days) {
    var expires = "";
  
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
  
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
  
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
  
    return null;
}

function closeAnnouncementBar() {
  setCookie('hide-announcement-bar', true, 30);
  jQuery('.announcement-bar').slideUp('slow');
}

function showAnnouncementBar() {
  jQuery('.announcement-bar').slideDown('slow');
}

jQuery(function() {
  if(!getCookie('hide-announcement-bar')) {
    showAnnouncementBar();
  }
  
  jQuery('#shopify-section-footer .navigation h6').click(function() {
    var $this = jQuery(this),
        $list = $this.next();
        
    if($this.hasClass('expanded')) {
      $list.css('max-height', 0);
      
      $this.removeClass('expanded');
      $list.removeClass('expanded');
    } else {
      $list.css('max-height', $list.prop('scrollHeight'));
      
      $this.addClass('expanded');
      $list.addClass('expanded');
    }
  });
  
  jQuery('#mobile-menu .links .has-dropdown > span').click(function() {
    var $this = jQuery(this),
        $list = $this.next();
        
    if($this.hasClass('expanded')) {
      $list.css('max-height', 0);
      
      $this.removeClass('expanded');
      $list.removeClass('expanded');
    } else {
      $list.css('max-height', $list.prop('scrollHeight'));
      
      $this.addClass('expanded');
      $list.addClass('expanded');
    }
  });
});